import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    solicitudes: [],
    estatusSolicitudes: [],
    estatusSolicitudesACNacional: [],
    estatusSolicitudesACExportacion: [],

    solicitudesRevicionOC:[],
    solicitudesSeguimientoOC:[]
}

const GET_SOLICITUDES_UIFC01_ESTATUS = 'GET_SOLICITUDES_UIFC01_ESTATUS'
const GET_SOLICITUDES_AC_ESTATUS = 'GET_SOLICITUDES_AC_ESTATUS'
const GET_SOLICITUDES_UIFC01 = 'GET_SOLICITUDES_UIFC01'
const GET_DICTAMEN = 'GET_DICTAMEN'
const GET_SOLICITUDES_REVISION_OC_ESTATUS = 'GET_SOLICITUDES_REVISION_OC_ESTATUS'
const GET_SOLICITUDES_SEGUIMIENTO_OC_ESTATUS = 'GET_SOLICITUDES_SEGUIMIENTO_OC_ESTATUS'
const GET_SOLICITUDES_AC_EXPORTACION_ESTATUS = 'GET_SOLICITUDES_AC_EXPORTACION_ESTATUS'
//MÉTODOS 
export const obtenerSolicitudesUIFC01EstatusAdminRecibidas = createAsyncThunk(
    GET_SOLICITUDES_UIFC01_ESTATUS,
    async (id) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerSolicitudesUIFC01EstatusAdminRecibidas/${id}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const obtenerSolicitudesUIFC01EstatusAuxiliarRecibidas = createAsyncThunk(
    GET_SOLICITUDES_UIFC01_ESTATUS,
    async (revisor) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerSolicitudesAuxiliarRecibidas/${revisor}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const obtenerSolicitudesACEstatusNacional = createAsyncThunk(
    GET_SOLICITUDES_AC_ESTATUS,
    async (estatus) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerSolicitudesEstatusACNacional/${estatus}`
            const res = await axios.get(fullUrl)
            let fc_01_solicitudderegistro = []
            let fc_08_solicitudrenvacioncertificados = []
            let fc_33_solicitudenvasadonacional = []
            let fc_36_solicituddeactualizacion = []
            let fc_41_solicitudparabebidasconmezcal = []
            if (res.data.data.fc_01_solicitudderegistro) {
                for (let datos of res.data.data.fc_01_solicitudderegistro) {
                    for (let i in datos) {
                        fc_01_solicitudderegistro.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_33_solicitudenvasadonacional) {
                for (let datos of res.data.data.fc_33_solicitudenvasadonacional) {
                    for (let i in datos) {
                        fc_33_solicitudenvasadonacional.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_08_solicitudrenvacioncertificados) {
                for (let datos of res.data.data.fc_08_solicitudrenvacioncertificados) {
                    for (let i in datos) {
                        fc_08_solicitudrenvacioncertificados.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_41_solicitudparabebidasconmezcal) {
                for (let datos of res.data.data.fc_41_solicitudparabebidasconmezcal) {
                    for (let i in datos) {
                        fc_41_solicitudparabebidasconmezcal.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_36_solicituddeactualizacion) {
                for (let datos of res.data.data.fc_36_solicituddeactualizacion) {
                    for (let i in datos) {
                        fc_36_solicituddeactualizacion.push(datos[i])
                    }
                }
            }
            let solicitudes = []
            solicitudes.push({
                fc_01_solicitudderegistro: fc_01_solicitudderegistro,
                fc_08_solicitudrenvacioncertificados: fc_08_solicitudrenvacioncertificados,
                fc_33_solicitudenvasadonacional: fc_33_solicitudenvasadonacional,
                fc_36_solicituddeactualizacion: fc_36_solicituddeactualizacion,
                fc_41_solicitudparabebidasconmezcal: fc_41_solicitudparabebidasconmezcal,
            })
            return solicitudes?.[0]
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const obtenerSolicitudesACEstatusExportacion = createAsyncThunk(
    GET_SOLICITUDES_AC_EXPORTACION_ESTATUS,
    async (estatus) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerSolicitudesEstatusACExportacion/${estatus}`
            const res = await axios.get(fullUrl)
            let fc_08_solicitudrenvacioncertificados = []
            let fc_09_solicitudemicioncertificadonomexportacionyentregahologram = []
            let fc_41_solicitudparabebidasconmezcal = []
            if (res.data.data.fc_08_solicitudrenvacioncertificados) {
                for (let datos of res.data.data.fc_08_solicitudrenvacioncertificados) {
                    for (let i in datos) {
                        fc_08_solicitudrenvacioncertificados.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_09_solicitudemicioncertificadonomexportacionyentregahologram) {
                for (let datos of res.data.data.fc_09_solicitudemicioncertificadonomexportacionyentregahologram) {
                    for (let i in datos) {
                        fc_09_solicitudemicioncertificadonomexportacionyentregahologram.push(datos[i])
                    }
                }
            }
            if (res.data.data.fc_41_solicitudparabebidasconmezcal) {
                for (let datos of res.data.data.fc_41_solicitudparabebidasconmezcal) {
                    for (let i in datos) {
                        fc_41_solicitudparabebidasconmezcal.push(datos[i])
                    }
                }
            }
            let solicitudes = []
            solicitudes.push({
                fc_08_solicitudrenvacioncertificados: fc_08_solicitudrenvacioncertificados,
                fc_09_solicitudemicioncertificadonomexportacionyentregahologram: fc_09_solicitudemicioncertificadonomexportacionyentregahologram,
                fc_41_solicitudparabebidasconmezcal: fc_41_solicitudparabebidasconmezcal,
            })
            return solicitudes?.[0]
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const obtenerSolicitudesUIFC01 = createAsyncThunk(
    GET_SOLICITUDES_UIFC01,
    async (estatus) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerSolicitudesUIFC01/${estatus}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const obtenerDictamen = createAsyncThunk(
    GET_DICTAMEN,
    async (data) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerTodosDictamenes/${data.idoficio}&${data.idsolicitudesuifc01}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const obtenerSolicitudesFC01RevicionNacionalAdmin = createAsyncThunk(
    GET_SOLICITUDES_REVISION_OC_ESTATUS,
    async (id) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerSolicitudesFC01RevicionNacionalAdmin/${id}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const obtenerSolicitudesFC01RevisionNacionalAuxiliar = createAsyncThunk(
    GET_SOLICITUDES_REVISION_OC_ESTATUS,
    async (revisor) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerSolicitudesRevicionNacionalAuxiliar/${revisor}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const obtenerSolicitudesFC01SeguimientoNacionalAdmin = createAsyncThunk(
    GET_SOLICITUDES_SEGUIMIENTO_OC_ESTATUS,
    async (id) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerSolicitudesFC01SeguimientoNacionalAdmin/${id}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const obtenerSolicitudesFC01SeguimientoNacionalAuxiliar = createAsyncThunk(
    GET_SOLICITUDES_SEGUIMIENTO_OC_ESTATUS,
    async (revisor) => {
        try {
            const fullUrl = host + `SolicitudesEstatus/obtenerSolicitudesSeguimientoNacionalAuxiliar/${revisor}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const metodosEstatusSolicitudesSlice = createSlice({

    name: 'metodosEstatusSolicitudesSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [obtenerSolicitudesUIFC01EstatusAdminRecibidas.fulfilled]: (state, { payload }) => {
            state.solicitudes = payload
        },
        [obtenerSolicitudesUIFC01EstatusAuxiliarRecibidas.fulfilled]: (state, { payload }) => {
            state.solicitudes = payload
        },
        [obtenerSolicitudesACEstatusNacional.fulfilled]: (state, { payload }) => {
            state.estatusSolicitudesACNacional = payload
        },
        [obtenerSolicitudesACEstatusExportacion.fulfilled]: (state, { payload }) => {
            state.estatusSolicitudesACExportacion = payload
        },
        [obtenerSolicitudesUIFC01.fulfilled]: (state, { payload }) => {
            state.estatusSolicitudes = payload
        },

        [obtenerSolicitudesFC01RevicionNacionalAdmin.fulfilled]: (state, { payload }) => {
            state.solicitudesRevicionOC = payload
        },
        [obtenerSolicitudesFC01RevisionNacionalAuxiliar.fulfilled]: (state, { payload }) => {
            state.solicitudesRevicionOC = payload
        },

        [obtenerSolicitudesFC01SeguimientoNacionalAdmin.fulfilled]: (state, { payload }) => {
            state.solicitudesSeguimientoOC = payload
        },
        [obtenerSolicitudesFC01SeguimientoNacionalAuxiliar.fulfilled]: (state, { payload }) => {
            state.solicitudesSeguimientoOC = payload
        },
    },

})


export const { } = metodosEstatusSolicitudesSlice.actions
export const EstatusSolicitudesUIF01Reducer = metodosEstatusSolicitudesSlice.reducer